<template>
  <iframe title="widget" class="widget-iframe" :src="widgetUrl" width="100%" height="100%" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen async />
</template>

<script>
import { demoRooms } from '@/enums/demoRooms';
import config from '@/config';

export default {
  name: 'Widget',
  data() {
    const rawQuery = new URLSearchParams(window.location.search);
    const query = new URLSearchParams();
    // eslint-disable-next-line
    for (const [key, value] of rawQuery) {
      query.append(key.toLowerCase(), value);
    }

    const domain = window.location.hostname.split('.').slice(-2).join('.');
    const language = config.domains[domain];
    if (language === 'ru') query.set('locale', 'ru');

    const style = query.get('style');
    const type = query.get('type');
    const newCameraId = demoRooms[style]?.[type]?.id;
    if (newCameraId) query.set('primarycamerapointid', newCameraId);

    const widgetUrl = [config.widgetUrl[language], decodeURIComponent(query)].join('?');

    return {
      widgetUrl,
    };
  },
};
</script>

<style scoped>
.widget-iframe {
  display: flex;
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden;
}
</style>
